import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import "core-js/modules/es6.number.is-integer.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.typed.int32-array.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.weak-map.js";
// A map from cell id to expression value that stores only the values which differ from a
// single repeated one (zero, for raw expression), because most cells do not express most
// genes.
//
// Everything is held in arrays.
// Values are held in a plain array rather than a Float64Array on purpose: `applyModifier`
// is used to turn expression values into colours (see plotUtils.colorByGeneExpression), so
// the value type is not always numeric.

// First index whose value is >= target, in an ascending array.
var lowerBound = function lowerBound(values, target) {
  var lo = 0;
  var hi = values.length;
  while (lo < hi) {
    var mid = lo + hi >>> 1;
    if (values[mid] < target) lo = mid + 1;else hi = mid;
  }
  return lo;
};
var isAscending = function isAscending(keys) {
  for (var i = 1; i < keys.length; i += 1) if (keys[i] <= keys[i - 1]) return false;
  return true;
};

// Cell ids are non-negative integers, so they fit an Int32Array. Anything else (a test
// fixture with string keys, say) stays in a plain array.
var packKeys = function packKeys(keys) {
  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];
    if (!Number.isInteger(key) || key < 0 || key > 2147483647) return keys;
  }
  return Int32Array.from(keys);
};
var _definedKeys = /*#__PURE__*/new WeakMap();
var _definedAscending = /*#__PURE__*/new WeakMap();
var _definedKeySet = /*#__PURE__*/new WeakMap();
var _storedKeys = /*#__PURE__*/new WeakMap();
var _storedValues = /*#__PURE__*/new WeakMap();
var _storedAscending = /*#__PURE__*/new WeakMap();
var _storedIndex = /*#__PURE__*/new WeakMap();
var _sparsifiedValue = /*#__PURE__*/new WeakMap();
var SparseMap = /*#__PURE__*/function () {
  function SparseMap(sparseRow, definedKeys, keyAsString) {
    var sparsifiedValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    _classCallCheck(this, SparseMap);
    _classPrivateFieldInitSpec(this, _definedKeys, void 0);
    _classPrivateFieldInitSpec(this, _definedAscending, void 0);
    _classPrivateFieldInitSpec(this, _definedKeySet, void 0);
    _classPrivateFieldInitSpec(this, _storedKeys, void 0);
    _classPrivateFieldInitSpec(this, _storedValues, void 0);
    _classPrivateFieldInitSpec(this, _storedAscending, void 0);
    _classPrivateFieldInitSpec(this, _storedIndex, void 0);
    _classPrivateFieldInitSpec(this, _sparsifiedValue, void 0);
    _classPrivateFieldSet(_sparsifiedValue, this, sparsifiedValue);

    // The embedding's gene-colouring path asks for string keys, because that is how cell
    // colour maps are keyed. Stringified ids are not lexicographically ordered, so those
    // maps fall back to the hashed lookup below rather than to a binary search.
    var asKey = keyAsString ? function (key) {
      return key.toString();
    } : function (key) {
      return key;
    };

    // sparseRow can come in the format for a Map constructor, in which case every key it
    // lists is both defined and explicitly stored.
    if (Array.isArray(sparseRow)) {
      var keys = new Array(sparseRow.length);
      var values = new Array(sparseRow.length);
      sparseRow.forEach(function (_ref, i) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        keys[i] = asKey(key);
        values[i] = value;
      });
      _classPrivateFieldSet(_definedKeys, this, packKeys(keys));
      _classPrivateFieldSet(_storedKeys, this, _classPrivateFieldGet(_definedKeys, this));
      _classPrivateFieldSet(_storedValues, this, values);
    } else {
      // Otherwise sparseRow is one column of a compressed column matrix, whose _index
      // entries are positions in definedKeys.
      _classPrivateFieldSet(_definedKeys, this, packKeys(definedKeys.map(asKey)));
      var index = sparseRow._index,
        _values = sparseRow._values;
      var storedKeys = new Array(index.length);
      var storedValues = new Array(index.length);
      for (var i = 0; i < index.length; i += 1) {
        storedKeys[i] = asKey(definedKeys[index[i]]);
        storedValues[i] = _values[i];
      }
      _classPrivateFieldSet(_storedKeys, this, packKeys(storedKeys));
      _classPrivateFieldSet(_storedValues, this, storedValues);
    }

    // mathjs keeps a column's _index ascending, so the stored keys are ascending whenever
    // the defined keys are -- which getFilteredCellIds guarantees by sorting. Checking is
    // one cheap pass and lets `get` be a binary search instead of a hash lookup.
    _classPrivateFieldSet(_definedAscending, this, isAscending(_classPrivateFieldGet(_definedKeys, this)));
    _classPrivateFieldSet(_storedAscending, this, _classPrivateFieldGet(_definedAscending, this) || isAscending(_classPrivateFieldGet(_storedKeys, this)));
    _classPrivateFieldSet(_definedKeySet, this, null);
    _classPrivateFieldSet(_storedIndex, this, null);
  }
  _createClass(SparseMap, [{
    key: "size",
    get: function get() {
      return _classPrivateFieldGet(_definedKeys, this).length;
    }
  }, {
    key: "has",
    value: function has(key) {
      if (_classPrivateFieldGet(_definedAscending, this)) {
        var at = lowerBound(_classPrivateFieldGet(_definedKeys, this), key);
        return at < _classPrivateFieldGet(_definedKeys, this).length && _classPrivateFieldGet(_definedKeys, this)[at] === key;
      }
      // Only reachable if a caller hands over unsorted keys; built once, on demand.
      if (_classPrivateFieldGet(_definedKeySet, this) === null) _classPrivateFieldSet(_definedKeySet, this, new Set(_classPrivateFieldGet(_definedKeys, this)));
      return _classPrivateFieldGet(_definedKeySet, this).has(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      var keys = _classPrivateFieldGet(_storedKeys, this);
      if (_classPrivateFieldGet(_storedAscending, this)) {
        var _at = lowerBound(keys, key);
        if (_at < keys.length && keys[_at] === key) return _classPrivateFieldGet(_storedValues, this)[_at];
        return _classPrivateFieldGet(_sparsifiedValue, this);
      }
      // Unordered keys (the stringified path). Hashing only the STORED keys still keeps the
      // per-cell-id structures out of it, and this map is at most the non-zero count.
      if (_classPrivateFieldGet(_storedIndex, this) === null) {
        _classPrivateFieldSet(_storedIndex, this, new Map());
        for (var i = 0; i < keys.length; i += 1) _classPrivateFieldGet(_storedIndex, this).set(keys[i], i);
      }
      var at = _classPrivateFieldGet(_storedIndex, this).get(key);
      return at === undefined ? _classPrivateFieldGet(_sparsifiedValue, this) : _classPrivateFieldGet(_storedValues, this)[at];
    }
  }, {
    key: "applyModifier",
    value: function applyModifier(modifier) {
      for (var i = 0; i < _classPrivateFieldGet(_storedValues, this).length; i += 1) {
        _classPrivateFieldGet(_storedValues, this)[i] = modifier(_classPrivateFieldGet(_storedValues, this)[i]);
      }
      _classPrivateFieldSet(_sparsifiedValue, this, modifier(_classPrivateFieldGet(_sparsifiedValue, this)));
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn) {
      for (var i = 0; i < _classPrivateFieldGet(_definedKeys, this).length; i += 1) {
        var key = _classPrivateFieldGet(_definedKeys, this)[i];
        callbackfn(this.get(key), key, this);
      }
    }

    // Only the entries that are explicitly stored, i.e. the ones that differ from the
    // sparsified value. Callers that can treat the rest as a count rather than visiting them
    // one by one should use this: it is the difference between O(non-zeros) and O(cells).
  }, {
    key: "forEachStored",
    value: function forEachStored(callbackfn) {
      for (var i = 0; i < _classPrivateFieldGet(_storedKeys, this).length; i += 1) {
        callbackfn(_classPrivateFieldGet(_storedValues, this)[i], _classPrivateFieldGet(_storedKeys, this)[i], this);
      }
    }
  }, {
    key: "storedSize",
    get: function get() {
      return _classPrivateFieldGet(_storedKeys, this).length;
    }
  }, {
    key: "sparsifiedValue",
    get: function get() {
      return _classPrivateFieldGet(_sparsifiedValue, this);
    }
  }, {
    key: "keys",
    value: function keys() {
      return _classPrivateFieldGet(_definedKeys, this);
    }
  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var i, key;
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            i = 0;
          case 1:
            if (!(i < _classPrivateFieldGet(_definedKeys, this).length)) {
              _context.next = 8;
              break;
            }
            key = _classPrivateFieldGet(_definedKeys, this)[i];
            _context.next = 5;
            return [key, this.get(key)];
          case 5:
            i += 1;
            _context.next = 1;
            break;
          case 8:
          case "end":
            return _context.stop();
        }
      }, value, this);
    })
  }]);
  return SparseMap;
}();
export default SparseMap;